import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_master-roads-build/artifacts/gxcvn7yx_39676.png";

export default function Logo({ className = "", size = 64 }) {
    return (
        <Link
            to="/"
            data-testid="logo-link"
            className={`flex items-center group ${className}`}
        >
            <img
                src={LOGO_URL}
                alt="TreadMasters"
                width={size}
                height={size}
                className="transition-all duration-300 group-hover:scale-105"
                style={{ width: size, height: size, objectFit: "contain" }}
            />
            <span className="sr-only">TreadMasters</span>
        </Link>
    );
}
